const getDefaultState = () => {
  return {
    width: null,
    height: null
  }
}

const state = getDefaultState()

const actions = {
  updateRes (context, payload) {
    context.commit('saveRes', payload)
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  saveRes (state, res) {
    state.width = res.width
    state.height = res.height
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
